import { adminRoleDropdownFieldDef } from '../../data/data';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { UsersOfOrg } from './UsersOfOrg';

export class UsersOfOrgCustom extends UsersOfOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'CUSTOM'})
  }

}


// WEBPACK FOOTER //
// ./src/common/components/UsersOfOrgCustom.js